<script>
export default {
  name: "socialSection"
};
</script>

<template>
  <el-row style="padding: 40px 16px 40px 16px; background-color: #2D2D2D">
    <el-col :span="24">
      <span class="social-font">#<b>UNIFI</b>Property</span>
    </el-col>
    <el-col :span="24" class="flex-centered">
      <img
        loading="lazy"
        src="../../assets/social-image.jpg"
        style="width: 343px; height: 250px"
      />
    </el-col>
  </el-row>
</template>

<style scoped>
.flex-centered {
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 30px;
}

.social-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/package/socialSection.vue